import EncyclopediaBookIcon from '~/components/Icons/svgs/EncyclopediaBookIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { LearningPathColors } from '~/dashboard/types/dashboard.types'

interface Props {
  className: string
  color: LearningPathColors
  size: string
  id: string
}

export default function EncyclopediaIcon({ className, color, size, id }: Props): React.ReactElement {
  const isLarge = size === 'large'
  return (
    <div className={className}>
      <SVGIcon
        className="relative hover:scale-110 duration-300"
        colorMatrix={color.colorMatrix}
        gradientStart={color.start}
        gradientStop={color.stop}
        icon={EncyclopediaBookIcon}
        id={id}
        size={size === 'x-small' ? 39 : isLarge ? 88 : 42}
      />
    </div>
  )
}
